// extracted by mini-css-extract-plugin
module.exports = {"filterNewsCards":"filterPage_filterNewsCards__ATVZ7"};